import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorPageDialogComponent } from "app/shared/error-page-dialog/error-page-dialog.component";

interface ErrorPage {
  message?: string;
  route?: string;
  button?: string;
}

@Injectable({
  providedIn: "root",
})
export class ErrorHandlerService {
  private dialogComponent = undefined;

  constructor(private dialog: MatDialog) {}

  displayErrorPage(errorPage: ErrorPage) {
    if (this.dialogComponent === undefined) {
      this.dialogComponent = this.dialog.open(ErrorPageDialogComponent, {
        width: "80vw",
        height: "200px",
        data: {
          messageToDisplay: errorPage.message ?? "Data cannot be fetched",
          buttonToDisplay: errorPage.button ?? "Return to home",
          route: errorPage.route ?? "",
        },
        panelClass: "fetch-error-background",
      });
      this.dialogComponent
        .afterClosed()
        .pipe()
        .subscribe(() => (this.dialogComponent = undefined));
    }
  }
}
